import { Form } from 'antd';
import { messages, placeHolders } from '../../../../../../constants';
import { CustomSelect } from '../../../../../uiComponents/CustomSelect';

export const PackageSelect = ({ packs, setPackageId }) => {
  return (
    <Form.Item
      label="Paquetes"
      name="packageId"
      rules={[{ required: true, message: messages.required('Paquetes') }]}
    >
      <CustomSelect
        allowClear
        placeholder={placeHolders.package}
        onChange={setPackageId}
        options={packs?.map(({ id, name }) => ({
          value: id,
          label: name,
        }))}
      />
    </Form.Item>
  );
};
